<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs"
           :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab v-if="$canAny(['view-staff','edit-staff',' create-staff'])"  icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? ' Staff' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <staff-users/>
      </div>
    </vs-tab>
    <vs-tab v-if="$canAny(['view-staff-role','edit-staff-role',' create-staff-role'])" icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? 'Staff Group Profiles' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <staff-group-profile/>
      </div>
    </vs-tab>
    <vs-tab v-if="$canAny(['view-staff-departments','edit-staff-departments','create-staff-departments'])" icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? ' Departments & Teams' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <staff-departments/>
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import StaffUsers from './tabs/StaffUsers.vue'
import StaffGroupProfile from './tabs/StaffGroupProfile.vue'
import StaffDepartments from './tabs/StaffDepartments.vue'
import TreeTest from './tabs/TreeTest.vue'
// import PendingUsersList from './PendingUsersList.vue'
import Vue from 'vue';


export default {
  components: {
    StaffUsers,
    StaffGroupProfile,
    StaffDepartments,
    TreeTest
    // PendingUsersList,
  },
  data () {
    return {
      isActiveManageStaff: this.$can('view-staff'),
    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
